import { useContext } from "react";
import { PlayerContext } from "../context/PlayerContext";

const usePlayerData = () => {
  return useContext(PlayerContext);
};
export default usePlayerData;
